import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { OrientationFilter } from "~/components/Filters/OrientationFilter/OrientationFilter";
import { StringArrayFilterCard } from "~/components/Filters/StringArrayFilterCard";
import { ORIENTATION_FILTER_CARD } from "~/constants/testIDs";
export const OrientationFilterCard = /*#__PURE__*/ memo((props)=>{
    const renderOrientationSelect = useCallback((props)=>/*#__PURE__*/ _jsx(OrientationFilter, {
            ...props
        }), []);
    return /*#__PURE__*/ _jsx(StringArrayFilterCard, {
        filter: "orientations",
        filterCardType: "orientation",
        StringSelect: renderOrientationSelect,
        "data-testid": ORIENTATION_FILTER_CARD,
        ...props
    });
});
OrientationFilterCard.displayName = "OrientationFilterCard";
